import {requests,requestsAsync,getToken} from './http';

/**
 * 重新发货任务
 */
export function reOnlineSendTask(data){
    const url = '/PurchaseOrder/ReOnlineSendTask'
    return req(url,data);
}

/**
 * 获取任务
 * @param {{TaskCode:string}} data 
 * @returns 
 */
export function getZhuKeReqTask(data){
    const url = '/Common/GetZhuKeReqTask'
    return req(url,data);
}

/**
 * 触发同步
 */
export function triggerSync(data){
    const url = '/Order/TriggerSync'
    return req(url,data);
}

/**
 * 获取类目映射
 */
export function GetMatchingCategoryRequest(data){
    const url = '/BatchDistribution/GetMatchingCategory'
    return req(url,data);
}

/**
 * 铺货
 */
export function BatchListingMobileByProductIdListV2Request(data){
    const url = '/BatchDistribution/BatchListingMobileByProductIdListV2'
    return req(url,data);
}

/**
 * 获取供应商货源信息
 * @param { {SupplierProductId} } data
 * @returns 
 */
export function loadSupplierProduct(data){
    const url = '/Product/LoadSupplierProduct'
    return req(url,data);
}

/**
 * 商品同步
 * @param { { ShopIdList : int[] | numberString}} data 
 * @returns 
 */
export function syncProduct(data){
    const url = '/Product/SyncProduct'
    return req(url,data);
}

/**
 * 获取最后同步时间
 * @param { { ShopIdList:int[] }} data 
 * @returns 
 */
export function isProductSucceed(data){
    const url = '/Product/IsProductSucceed'
    return req(url,data);
}

/**
 * 获取同步进度
 * 
 * Sid_PlatformType参数数组中key为shopId，value为平台
 * @param {{Sid_PlatformType:[{Key:int,Value:string}]}} data 
 * @returns 
 */
export function getSyncStatus(data){
    const url = '/Order/GetSyncStatus'
    return req(url,data);
}
/**
 * 获取进度
 * @param { {ShopIds:int[], SyncType:int}} data 
 * @returns 
 */
export function getSyncStatusProccess(data){
    const url = '/Common/GetSyncStatusProccess'
    return req(url,data);
}  

/**
 * 获取店铺最后同步时间
 * @param { { ShopIds:int[], SyncType:int , PlatformType : string }} data 
 * @returns { string }
 */
export function getLastSyncTime(data){
    const url = '/Common/GetLastSyncTime'
    return req(url,data);
}

/**
 * 保存上传尺寸模板信息
 */
export function saveSizeComponentTamplate(data)
{
    const url = '/DistributionLog/SaveSizeComponentTamplate'
    return req(url,data);
}

/**
 * 获取模板信息
 */
 export function loadSizeComponentTamplate(data)
 {
     const url = '/DistributionLog/LoadSizeComponentTamplate'
     return req(url,data);
 }

 export function saveOrderSkuMapping(data){
    const url = '/BatchDistribution/SaveOrderSkuMapping'
    return req(url,data);
}

export function SaveOrderSkuMappingV2Request(data){
    const url = '/BatchDistribution/SaveOrderSkuMappingV2'
    return req(url,data);
}

/**
 * 获取品牌
 * @param { {QueryKey :string, CateId:string,ShopId:number,TargetPlatformType:string}} data 
 * @returns 
 */
export function GetCategoryBrandsRequest(data){
    const url = '/CateMapping/GetCategoryBrands'
    return req(url,data);
}

/**
 * @returns 
 */
export function GetListingProductByCateIdRequest(data){
    const url = '/BatchDistribution/GetListingProductByCateId'
    return req(url,data);
}

export function VerificationCategoryV2Request(data){
    const url = '/BatchDistribution/VerificationCategoryV2'
    return req(url,data);
}

/**
 * @returns 
 */
export function SaveOrSavePuHuoSupplierRequest(data){
    const url = '/product/SaveOrSavePuHuoSupplier'
    return req(url,data);
}
/**
 * 获取品牌
 * @param { {RelationCode:string}} data 
 * @returns 
 */
export function GetUserPreviewProductInfoByRelationCodeRequest(data){
    const url = '/BatchDistribution/GetUserPreviewProductInfoByRelationCode'
    return req(url,data);
}

/**
 * 获取铺货任务数据
 * @param { { TaskCode:string,TaskCates:[] } } data 
 * @returns 
 */
export function getTaskEditResult(data){
    const url = '/BatchDistribution/GetTaskEditResult'
    return req(url,data);
}

/**
 * 重新铺货
 * @param {*} data 
 * @returns 
 */
export function retryTaskEditResult(data)
{
    const url = '/BatchDistribution/RetryTaskEditResult'
    return req(url,data);
}

/**
 * 绑定授权1688店铺
 * @param {*} data 
 * @returns 
 */
export function bindOnwerShop(data)
{
    const url = '/MyShop/BindOnwerShop'
    return req(url,data);
}


/**
 * 检查旧应用未到期店铺
 * @param {*} data 
 * @returns 
 */
 export function checkOldAppShopExpire(data)
 {
     const url = '/MyShop/CheckOldAppShopExpire'
     return req(url,data);
 }
 
 /**
  * 
  * @param {*} data 
  * @returns 
  */
 export function shopOldApplicationNotExpired(data)
 {
    const url = '/MyShop/ShopOldApplicationNotExpired'
    return req(url,data);
 }

/**
 * 获取级联属性
 * @param {*} data 
 */
export function getCategoryProps(data)
{
    const url = '/BatchDistribution/GetCategoryProps'
    return req(url,data);
}

/**
 * 获取供应商标记列表
 * @param { { MarkeType:string,SupplierLoginId:string}} data 
 * @returns 
 */
export function SupplierMarkeListRequest(data)
{
    const url = '/Supplier/SupplierMarkeList'
    return req(url,data);
}

/**
 * 保存供应商标记
 * @param { { MarkeType:string,SupplierLoginId:string}} data 
 * @returns 
 */
 export function SaveSupplierMarkeRequest(data)
 {
     const url = '/Supplier/SaveSupplierMarke'
     return req(url,data);
 }

 /**
 * 淘口令匹配
 * @param { { Links:string[]}} data 
 * @returns 
 */
 export function MatchTaoteLinkRequest(data)
 {
     const url = '/BatchDistribution/MatchTaoteLink'
     return req(url,data);
 }

 /**
  * 图片搜款
  * @param {{ Images:Arrar<String>,SourcePlatform:String}} data 
  */
 export function ImageSearchProductRequest(data)
 {
    var zhukeTokenTwo = getToken();
    if(zhukeTokenTwo){
        const url = '/Product/ImageSearchProduct'
        return req(url,data);
    }else{
        const url = '/ShopCommon/ImageSearchProduct'
        return req(url,data,true);
    }
 }

 /**
  */
 export function GetAliChoicenessProductDetailRequest(data)
 {
    var zhukeTokenTwo = getToken();
    if(zhukeTokenTwo){
        const url = '/Product/GetAliChoicenessProductDetail'
        return req(url,data);
    }else{
        const url = '/ShopCommon/GetAliChoicenessProductDetail'
        return req(url,data,true);
    }
 }

 /**
  */
 export function GetAliCategorysRequest(data)
 {
    var zhukeTokenTwo = getToken();
    // if(zhukeTokenTwo){
    //     const url = '/Product/GetAliCategorys'
    //     return req(url,data);
    // }else{
        const url = '/ShopCommon/GetAliCategorys'
        return req(url,data,true);
    //}
 }


 /**
  * 淘货源查询参数
  * @param {*} data 
  * @returns 
  */
 export function TaoteProductParameRequest(data)
 {
    const url = '/Product/TaoteProductParame'
    return req(url,data);
 }

 /**
  * 货源查询
  * @param {*} data 
  * @returns 
  */
 export function QuerySupplierProductsRequest(data){
    const url = '/Product/QuerySupplierProducts'
    return req(url,data);
 }


 /**
  * 获取buyerShop简要信息
  * @param {*} data 
  * @returns 
  */
 export function GetBuyerShopUserInfoRequest(data){
    const url = '/Common/GetBuyerShopUserInfo'
    return req(url,data);
 }

 /**
  * 淘特二维码生成
  * @param {*} data 
  * @returns 
  */
 export function TaoteGenerateQRCodeRequest(data){
    const url = '/Auth/TaoteGenerateQRCode'
    return req(url,data);
 }

/**
 * 通过授权code，进行授权
 * @param {*} data 
 * @returns 
 */
export function TaoteAuthRequest(data){
    const url = '/Auth/TaoteAuth'
    return req(url,data);
}

/**
 * 
 * @param {*} data 
 * @returns 
 */
export function GetZhuKeCommAlibabaByAloneRequest(data){
    const url = '/Auth/GetZhuKeCommAlibabaByAlone'
    return req(url,data);
}

/**
 * 获取任务
 * @param {{TaskCode:string}} data 
 * @returns 
 */
export function GetAuthTaskRequest(data){
    const url = '/Auth/GetZhuKeReqTask'
    return req(url,data);
}

/**
 * 系统配置
 * @param {*} data 
 * @returns 
 */
export function GetSystemUrlRequest(data){
    const url = '/MyShop/GetSystemUrl'
    return req(url,data);
}

/**
 * 解绑货源账号
 * @param { { BuyerShopId:int }} data 
 * @returns 
 */
export function UnBindBuyerShopRequest(data){
    const url = '/MyShop/UnBindBuyerShop'
    return req(url,data);
}

/**
 * @returns 
 */
export function GetAllPlatformLinkRequest(data){
    const url = '/MyShop/GetAllPlatformLink'
    return req(url,data);
}

/**
 * 添加动作日志
 * @param { } data 
 * @returns 
 */
export function AddSiteLogRequest(data){
    const url = '/Common/AddSiteLog'
    return req(url,data);
}

/**
 * 支付
 * @param { {Array:string} } data 
 * @returns 
 */
export function GetPayUrlRequest(data){
    const url = '/PurchaseOrder/GetPayUrl'
    return req(url,data);
}

/**
 * 支付结果
 * @param {*} data 
 * @returns 
 */
export function GetPayResultRequest(data){
    const url = '/PurchaseOrder/GetPayResult'
    return req(url,data);
}

/**
 * 取消订单
 * @param {*} data 
 * @returns 
 */
export function CancelPurchaseOrderRequest(data){
    const url = '/PurchaseOrder/CancelPurchaseOrder'
    return req(url,data);
}

/**
 * 同步订单
 * @param {*} data 
 * @returns 
 */
export function SyncOrderByIdsRequest(data){
    const url = '/Order/SyncSingleOrder'
    return req(url,data);
}

/**
 * 添加动作日志
 * @param { } data 
 * @returns 
 */
export function AddSiteLogByShopRequest(data){
    const url = '/Auth/AddSiteLogByShop'
    return req(url,data);
}

/**
 * 分销货源查询
 * @param { { Keyword:string,OrderBy:string,Sort:string,MinPrice:number,MaxPrice:number,CategoryId:string,PageIndex:number,PageSize:number} } data 
 * @returns 
 */
export function QueryFenXiaoProducts(data){
    const url = '/Product/QueryFenXiaoProducts'
    return req(url,data);
}
export function QueryBdyProducts(data){
    const url = '/Product/QueryPoolProducts'
    return req(url,data);
}

/**
 * 精选货源初始化数据
 * @param { } data 
 * @returns 
 */
export function GetFenXiaoProductConfig(data){
    const url = '/Product/GetFenXiaoProductConfig'
    return req(url,data);
}

/**
 * 加载联系客服
 */
export function LoadContactWayRequest(data){
    const url = '/Auth/LoadContactWayByShop'
    return req(url,data);
}

/**
 * 加载快捷导航数据
 */
export function GetQuickGuideDataRequest(data){
    const url = '/Common/GetQuickGuideData'
    return req(url,data);
}

/**
 * 获取订单标签
 * @param { { OiCodes:Array<string>,ShopId,PlatformType}} data 
 * @returns 
 */
export function OrderTagsListRequest(data)
{
    const url = '/PurchaseOrder/OrderTagsList'
    return req(url,data);
}

/**
 * 获取下单配置
 */
export function GetOrderConfigRequest(data)
{
    const url = '/Order/GetOrderConfig'
    return req(url,data);
}

/**
 * 保存下单配置
 * IsAutoEncryptMark == 1 标识开启自动标记密文下单
 *  @param { { IsAutoEncryptMark: number}} data 
 */
export function SaveOrderConfigRequest(data)
{
    const url = '/Order/SaveOrderConfig'
    return req(url,data);
}

/**
 * 获取商品列表
 * @param { { }} data 
 * @returns 
 */
export function GetProductImageTextListRequest(data)
{
    const url = '/Product/GetProductImageTextList'
    return req(url,data);
}
/**
 * 保存图文信息
 * @param { { OiCodes:Array<string>,ShopId,PlatformType}} data 
 * @returns 
 */
export function SaveProductImageTextRequest(data)
{
    const url = '/Product/SaveProductImageText'
    return req(url,data);
}

/**
 * 图文发布
 * @param { { OiCodes:Array<string>,ShopId,PlatformType}} data 
 * @returns 
 */
export function ApplyProductImageTextRequest(data)
{
    const url = '/Product/ApplyProductImageText'
    return req(url,data);
}

/**
 * 头条平台bgm列表
 * @returns 
 */
export function GetTouTiaoBgmListRequest(data)
{
    const url = '/Product/GetTouTiaoBgmList'
    return req(url,data);
}
/**
 * 头条商品详情
 * @returns 
 */
export function ProductImageTextDetailRequest(data)
{
    const url = '/Product/ProductImageTextDetail'
    return req(url,data);
}
/**
 * 平台图片上传
 * @returns 
 */
export function PlatformUploadImageRequest(data)
{
    const url = '/BatchDistribution/PlatformUploadImage'
    return req(url,data);
}
/**
 * 校验图文问题
 * @returns 
 */
export function ImageTextShopAccessThresholdRequest(data)
{
    const url = '/Product/ImageTextShopAccessThreshold'
    return req(url,data);
}


/**
 * 校验图文问题
 * @returns 
 */
export function LevelListingCategoryRequest(data)
{
    const url = '/ListingConfig/LevelListingCategory'
    return req(url,data);
}

/**
 * 同步类目
 * @param { { TargetShopIds:Array<Number>,FromUserTrigger:bool }} data 
 * @returns 
 */
export function SyncCategoryRequest(data){
    const url = '/BatchDistribution/SyncCategory'
    return req(url,data);
}


/**
 * 规格映射列表
 * @param { { ShopId:item}} data 
 * @returns 
 */
export function LoadProductSkuMappingV2Request(data)
{
    const url = '/Product/LoadProductSkuMappingV2'
    return req(url,data);
}

/**
 * 保存规格映射
 * @param { { ShopId:item}} data 
 * @returns 
 */
export function RelateProductV2Request(data)
{
    const url = '/BatchDistribution/RelateProductV2'
    return req(url,data);
}
/**
 * 代销商品列表
 * @param { { ShopId:item}} data 
 * @returns 
 */
export function GetConsignProductListV2Request(data)
{
    const url = '/BatchDistribution/GetConsignProductListV2'
    return req(url,data);
}

/**
 */
export function RelateTemporaryProductV2Requset(data){
    const url = '/PurchaseOrder/RelateTemporaryProductV2'
    return req(url,data);
}

/**
 */
export function ShopListRequest(data){
    const url = '/MyShop/List'
    return req(url,data);
}
const MyShopRequest = {
    List:(data) => req('/MyShop/List',data)
}
const batchDistributionRequest = {
    SupplerList : (data) => req('/BatchDistribution/SupplerList',data),
    SupplierRelationTermination : (data) => req('/BatchDistribution/SupplierRelationTermination',data),
    SupplerProductList : (data) => req('/BatchDistribution/SupplerProductList',data),
    SupplerProductListByOfferId : (data) => req('/BatchDistribution/SupplerProductListByOfferId',data),
    BatchListing : (data) => req('/BatchDistribution/BatchListing',data),
    BatchListingMobileByProductIdList : (data) => req('/BatchDistribution/BatchListingMobileByProductIdList',data),
    GetOfferIdsByUniqueKey : (data) => req('/BatchDistribution/GetOfferIdsByUniqueKey',data),
    ListingTaskCallback : (data) => req('/BatchDistribution/ListingTaskCallback',data),
    SaveCateMapping : (data) => req('/BatchDistribution/SaveCateMapping',data),
    GetRelation : (data) => req('/BatchDistribution/GetRelation',data),
    RelateProduct : (data) => req('/BatchDistribution/RelateProduct',data),
    RelateProductV2 : (data) => req('/BatchDistribution/RelateProductV2',data),
    FawRelateProduct : (data) => req('/BatchDistribution/FawRelateProduct',data),
    SyncProductInfo : (data) => req('/BatchDistribution/SyncProductInfo',data),
    SyncProductInfoTask : (data) => req('/BatchDistribution/SyncProductInfoTask',data),
    VerificationCategory : (data) => req('/BatchDistribution/VerificationCategory',data),
    GetMatchingCategory : (data) => req('/BatchDistribution/GetMatchingCategory',data),
    BatchListingMatchingCates : (data) => req('/BatchDistribution/BatchListingMatchingCates',data),
    GetConsignProductList : (data) => req('/BatchDistribution/GetConsignProductList',data),
    GetConsignProductListByApi : (data) => req('/BatchDistribution/GetConsignProductListByApi',data),
    GetConsignProductListV2 : (data) => req('/BatchDistribution/GetConsignProductListV2',data),
    GetConsignProductListByApiV2 : (data) => req('/BatchDistribution/GetConsignProductListByApiV2',data),
    UnConsign : (data) => req('/BatchDistribution/UnConsign',data),
    SaveOrderSkuMapping : (data) => req('/BatchDistribution/SaveOrderSkuMapping',data),
    SaveOrderSkuMappingV2 : (data) => req('/BatchDistribution/SaveOrderSkuMappingV2',data),
    GetTaskEditResult : (data) => req('/BatchDistribution/GetTaskEditResult',data),
    RetryTaskEditResult : (data) => req('/BatchDistribution/RetryTaskEditResult',data),
    PlatformUploadImage : (data) => req('/BatchDistribution/PlatformUploadImage',data),
    GetCategoryProps : (data) => req('/BatchDistribution/GetCategoryProps',data),
    BatchListingMobileByProductIdListV2 : (data) => req('/BatchDistribution/BatchListingMobileByProductIdListV2',data),
    MatchTaoteLink : (data) => req('/BatchDistribution/MatchTaoteLink',data),
    VerificationCategoryV2 : (data) => req('/BatchDistribution/VerificationCategoryV2',data),
    GetListingProductEditByAllPlatfromType : (data) => req('/BatchDistribution/GetListingProductEditByAllPlatfromType',data),
    GetUserPreviewProductInfoByRelationCode : (data) => req('/BatchDistribution/GetUserPreviewProductInfoByRelationCode',data),
    GetListingProductByCateId : (data) => req('/BatchDistribution/GetListingProductByCateId',data),
}
const commonRequest = {
    GetAndSaveCommonSet : (data) => req('/Common/GetAndSaveCommonSet',data),
    GetIndexByDistributionLogNumber : (data) => req('/Common/GetIndexByDistributionLogNumber',data),
    GetIndexByUserInfo : (data) => req('/Common/GetIndexByUserInfo',data),
    GetBuyerShopUserInfo : (data) => req('/Common/GetBuyerShopUserInfo',data),
    GetIndexByShopNumbers : (data) => req('/Common/GetIndexByShopNumbers',data),
    GetOpenAutoWithholdUrl : (data) => req('/Common/GetOpenAutoWithholdUrl',data),
    PayAndAuthVideoUrl : (data) => req('/Common/PayAndAuthVideoUrl',data),
    AlibabaKeFuWangWang : (data) => req('/Common/AlibabaKeFuWangWang',data),
    JavasScriptLog : (data) => req('/Common/JavasScriptLog',data),
    JavasScriptLogByAllUser : (data) => req('/Common/JavasScriptLogByAllUser',data),
    TopNotice : (data) => req('/Common/TopNotice',data),
    TopNoticeByOrder : (data) => req('/Common/TopNoticeByOrder',data),
    TopNoticeByIndex : (data) => req('/Common/TopNoticeByIndex',data),
    GetNewNotic : (data) => req('/Common/GetNewNotic',data),
    TopNoticeByIndexRight : (data) => req('/Common/TopNoticeByIndexRight',data),
    LoadContactWay : (data) => req('/Common/LoadContactWay',data),
    LoadYouHuiShowAndUrl  : (data) => req('/Common/LoadYouHuiShowAndUrl ',data),
    LoadTopNoticeCommon : (data) => req('/Common/LoadTopNoticeCommon',data),
    LoadUpgradeAppPayInfo : (data) => req('/Common/LoadUpgradeAppPayInfo',data),
    GetZhuKeReqTask : (data) => req('/Common/GetZhuKeReqTask',data),
    AddSiteLog : (data) => req('/Common/AddSiteLog',data),
    GetSyncStatusProccess : (data) => req('/Common/GetSyncStatusProccess',data),
    GetLastSyncTime : (data) => req('/Common/GetLastSyncTime',data),
    GetQuickGuideData : (data) => req('/Common/GetQuickGuideData',data),
    GetMarketingCampaignData : (data) => req('/Common/GetMarketingCampaignData',data),
}

const purchaseOrderRequest = {
    List : (data)=> req('/PurchaseOrder/List',data),
    GetSingleOrder : (data)=> req('/PurchaseOrder/GetSingleOrder',data),
    ConfirmSkuMapping : (data)=> req('/PurchaseOrder/ConfirmSkuMapping',data),
    CreateOrder : (data)=> req('/PurchaseOrder/CreateOrder',data),
    ReCreateOrder : (data)=> req('/PurchaseOrder/ReCreateOrder',data),
    ProtocalPayOpenConfirm : (data)=> req('/PurchaseOrder/ProtocalPayOpenConfirm',data),
    GetOrderPayType : (data)=> req('/PurchaseOrder/GetOrderPayType',data),
    AutoPay : (data)=> req('/PurchaseOrder/AutoPay',data),
    ClosePurchaseOrder : (data)=> req('/PurchaseOrder/ClosePurchaseOrder',data),
    GetPayUrl : (data)=> req('/PurchaseOrder/GetPayUrl',data),
    GetPayResult : (data)=> req('/PurchaseOrder/GetPayResult',data),
    GetOrderPayUrl : (data)=> req('/PurchaseOrder/GetOrderPayUrl',data),
    ReOnlineSend : (data)=> req('/PurchaseOrder/ReOnlineSend',data),
    ReOnlineSendTask : (data)=> req('/PurchaseOrder/ReOnlineSendTask',data),
    GetOnlineSendErrorMsg : (data)=> req('/PurchaseOrder/GetOnlineSendErrorMsg',data),
    CancelPurchaseOrderConfirm : (data)=> req('/PurchaseOrder/CancelPurchaseOrderConfirm',data),
    CancelPurchaseOrder : (data)=> req('/PurchaseOrder/CancelPurchaseOrder',data),
    GetSendErrorOrderExcel : (data)=> req('/PurchaseOrder/GetSendErrorOrderExcel',data),
    GetSendErrorOrderExcelTask : (data)=> req('/PurchaseOrder/GetSendErrorOrderExcelTask',data),
    BatchIgnoreOrder : (data)=> req('/PurchaseOrder/BatchIgnoreOrder',data),
    RelateTemporaryProduct : (data)=> req('/PurchaseOrder/RelateTemporaryProduct',data),
    RelateTemporaryProductV2 : (data)=> req('/PurchaseOrder/RelateTemporaryProductV2',data),
    /**
     * OiCodes订单OrderCode或者订单项OrderItemCode集合
     * @param { { OiCodes:Array<string>,ShopId,PlatformType}} data 
     * @returns 
     */
    OrderTagsList : (data)=> req('/PurchaseOrder/OrderTagsList',data),
    GetBuyerOrderLogisticsInfo : (data)=> req('/PurchaseOrder/GetBuyerOrderLogisticsInfo',data),
}
const orderRequest = {
    List : (data) => req('/Order/List',data),
    ListV2 : (data) => req('/Order/ListV2',data),
    TriggerSync : (data) => req('/Order/TriggerSync',data),
    TriggerSyncApi : (data) => req('/Order/TriggerSyncApi',data),
    SyncSingleOrder : (data) => req('/Order/SyncSingleOrder',data),
    SyncSingleOrderApi : (data) => req('/Order/SyncSingleOrderApi',data),
    GetSyncStatus : (data) => req('/Order/GetSyncStatus',data),
    GetSyncStatusApi : (data) => req('/Order/GetSyncStatusApi',data),
    GetLastSyncTimeByShop : (data) => req('/Order/GetLastSyncTimeByShop',data),
    GetSyncLog : (data) => req('/Order/GetSyncLog',data),
    GetOrderConfig : (data) => req('/Order/GetOrderConfig',data),
    SaveOrderConfig : (data) => req('/Order/SaveOrderConfig',data),
}
const listingConfigRequest = {
    GetListingCategory : (data) => req('/ListingConfig/GetListingCategory',data),
    SearchCategories : (data) => req('/ListingConfig/SearchCategories',data),
    SyncShopCate : (data) => req('/ListingConfig/SyncShopCate',data),
    GetTemplatesBySid : (data) => req('/ListingConfig/GetTemplatesBySid',data),
    GetConfigValue : (data) => req('/ListingConfig/GetConfigValue',data),
    SaveConfigValue : (data) => req('/ListingConfig/SaveConfigValue',data),
    SyncDyShopCate : (data) => req('/ListingConfig/SyncDyShopCate',data),
    SystemSetinfoConfigGet : (data) => req('/ListingConfig/SystemSetinfoConfigGet',data),
    SystemSetinfoConfigValue : (data) => req('/ListingConfig/SystemSetinfoConfigValue',data),
    GetApiByOpenPay : (data) => req('/ListingConfig/GetApiByOpenPay',data),
}
const productRequest = {
    LoadProductSkuMappingV2 : (data) => req('/Product/LoadProductSkuMappingV2',data),
    LoadSupplierProduct:(data) => req('/Product/LoadSupplierProduct',data),
}
/**
 * 运费模板
 * @returns 
 */
export function GetTemplatesBySidReqeust(data)
{
    const url = '/ListingConfig/GetTemplatesBySid'
    return req(url,data);
}

/**
 * 物流模板
 * @returns 
 */
export function GetLogisticsTemplatesBySidReqeust(data)
{
    const url = '/ListingConfig/GetLogisticsTemplatesBySid'
    return req(url,data);
}

export function getAfterSalePageData(data) {
   const url = '/AfterSaleOrder/GetAfterSalePage';
   return req(url, data);
}

/**
 * 售后单-同步接口
 */
export function SyncAfterSaleOrder(data) {
   const url = '/AfterSaleOrder/TriggerSync';
   return req(url, data);
}

/**
 * 售后单-获取同步进度
 *
 * Sid_PlatformType参数数组中key为shopId，value为平台
 * @param {{Sid_PlatformType:[{Key:int,Value:string}]}} data
 * @returns
 */
export function getAfterSaleSyncStatus(data) {
  const url = '/AfterSaleOrder/GetSyncStatus';
  return req(url, data);
}

/**
 * 售后单-订单列表售后数量统计
 */
export function getAfterSaleNumber(data) {
    const url = '/AfterSaleOrder/GetAfterSaleNumber';
    return req(url, data);
}

/**
 * 请求封装
 * @param {string} url 
 * @param {any} data 
 * @returns Promise
 */
function req(url,data,shopType){
    return requestsAsync({
        url:url,
        data:data,
        shopType:shopType
    })
}

export { req,MyShopRequest,batchDistributionRequest,commonRequest,purchaseOrderRequest,orderRequest,listingConfigRequest,productRequest }


// WEBPACK FOOTER //
// ./src/utils/api.js